<template>

  <CheckNonFatturati />

</template>

<script>
import CheckNonFatturati from '../components/fatturazione/CheckNonFatturati.vue'

export default {
  pageName: 'CheckNonFatturati',
  components: {
    CheckNonFatturati

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
